import { useTranslation } from 'react-i18next';

import { Modal, ModalAccessor } from '@steelbuy/modal-dialog';
import {
    ButtonDanger,
    ButtonSecondary,
    ModalContent,
    ModalContentActionBar,
    ModalContentMain,
} from '@steelbuy/ui-primitive';
import './DeleteBulkListingModal.scss';

export type DeleteDraftModalProps = {
    modalAccessor: ModalAccessor;
    onConfirm: () => void;
};

export const DeleteBulkListingModal = ({ modalAccessor, onConfirm }: DeleteDraftModalProps) => {
    const { t } = useTranslation(['translation', 'uiDomain']);

    return (
        <Modal modalAccessor={modalAccessor}>
            <div className="delete-bulk__content">
                <ModalContent
                    onCloseModal={modalAccessor.hide}
                    headline={t('application.createBulkListing.deleteModal.textContent')}
                >
                    <ModalContentMain imgSrc="/assets/lib-ui-primitive/images/DeleteItem.svg" />
                    <ModalContentActionBar>
                        <ButtonSecondary label={t('uiDomain:common.cancel')} onClick={modalAccessor.hide} />
                        <ButtonDanger label={t('uiDomain:deleteDraftModal.confirmButtonLabel')} onClick={onConfirm} />
                    </ModalContentActionBar>
                </ModalContent>
            </div>
        </Modal>
    );
};
